<div class="row">
    <div class="col-12">
        <agm-map [latitude]="lat" [longitude]="lng">
            <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
        </agm-map>
    </div>
</div>
<div class="row justify-content-center mt-4">
    <div class="col-xl-4 col-lg-6 col-md-8 col-sm-12 mat-elevation-z8">
        <div class="row heading mat-elevation-z8">
            <div class="col-12">
                <h1 class=" text-center  coolfont">Address</h1>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <p class="text-center"><mat-icon style="color: #02B1FF; font-size: 20px;">place</mat-icon>Flat No. 02 Park Apartments, South Civil Lines, near I.G. Bungalow/Office,<br> Jabalpur, Madhya Pradesh - 482001, IN</p>
                <p class="text-center"><mat-icon style="color: #02B1FF; font-size: 20px;">phone_iphone</mat-icon>0761-4045468</p>
            </div>
        </div>
    </div>
</div>
<div class="row justify-content-center mt-4">
    <div class="col col-xl-4 col-lg-6 col-md-8 col-sm-12 text-center coolfont heading mat-elevation-z8"><h1>Get In Touch</h1></div>
</div>
<div class="row justify-content-center">
    <div class="col col-xl-4 col-lg-6 col-md-8 col-sm-12 mat-elevation-z8">
        <form class="planform text-center" [formGroup]="exampleForm" novalidate (ngSubmit)="goSubmit(exampleForm.value)">
                      <div class="row">
                        <div class="col-12">
                        <mat-form-field style="width:75% !important">
                          <input matInput placeholder="E-mail" class="form-control" formControlName="uname">
                        </mat-form-field>
                        <ng-container *ngFor="let validation of validation_messages.uname">
                          <mat-error *ngIf="exampleForm.get('uname').hasError(validation.type) && (exampleForm.get('uname').dirty || exampleForm.get('uname').touched)">{{validation.message}}</mat-error>
                        </ng-container>
                        </div>
                      </div>
                        <div class="row">
                          <div class="col-12">
                            <mat-form-field>
                              <input matInput placeholder="Phone Number" type="number" class="form-control" formControlName="phn">
                            </mat-form-field>
                            <ng-container *ngFor="let validation of validation_messages.phn">
                              <mat-error *ngIf="exampleForm.get('phn').hasError(validation.type) && (exampleForm.get('phn').dirty || exampleForm.get('phn').touched)">{{validation.message}}</mat-error>
                            </ng-container>
                          </div>
                          <div class="col-12">
                            <mat-form-field style="width:75% !important">
                                <textarea matInput placeholder="Message" type="text" class="form-control" formControlName="message"></textarea>
                              </mat-form-field>
                          </div>
                      </div>
                        <div>
                            <button mat-raised-button class="signin" type="submit" [disabled]="!exampleForm.valid">Send</button>
                        </div>
                        <br>
        </form>
    </div>
</div>